import { FileOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Label per le righe omissis nelle tabelle moduli e allegati.
 */
export function OmissisSubRowLabel() {
  const { t } = useTranslation();

  return (
    <Typography.Text>
      <Space size={4}>
        ↳
        <FileOutlined />
        {t(
          'submission-summary.versione-pubblica-omissis',
          'Versione pubblica con Omissis',
        )}
      </Space>
    </Typography.Text>
  );
}
